import { TrackingReportsActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

export const INIT_STATE = {
    loadingDelayedFacilities: false,
    errorGetDelayedFacilities: null,
    delayedFacilities: null,
    delayedFacilitiesPagination: PAGINATION_DEFAULT_VALUE,
    loadingDelayedFacilitiesReport: false,
    errorGetDelayedFacilitiesReport: null,
    delayedFacilitiesReport: null,
    loadingShipmentTrackingRecords: false,
    errorGetShipmentTrackingRecords: null,
    shipmentTrackingRecords: null,
    shipmentTrackingRecordsPagination: PAGINATION_DEFAULT_VALUE,
    loadingShipmentTrackingReport: false,
    errorGetShipmentTrackingReport: null,
    shipmentTrackingReport: null,
    loadingAggregatedDelayedShipments: false,
    errorGetAggregatedDelayedShipments: null,
    aggregatedDelayedShipments: null,
    aggregatedDelayedShipmentsPagination: PAGINATION_DEFAULT_VALUE,
    loadingAggregatedDelayedShipmentsReport: false,
    errorGetAggregatedDelayedShipmentsReport: null,
    loadingAddressReport: false,
    errorGetAddressReport: null,
    addressReport: null,
    addressReportPagination: PAGINATION_DEFAULT_VALUE,
    loadingAddressReportFile: false,
    errorGetAddressReportFile: null,
    addressReportFile: null,
};

type TrackingReportsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    loadingDelayedFacilities: false,
    errorGetDelayedFacilities: null,
    delayedFacilities: null,
    delayedFacilitiesPagination: null,
    loadingDelayedFacilitiesReport: false,
    errorGetDelayedFacilitiesReport: null,
    delayedFacilitiesReport: null,
    loadingShipmentTrackingRecords: false,
    errorGetShipmentTrackingRecords: null,
    shipmentTrackingRecords: null,
    shipmentTrackingRecordsPagination: null,
    loadingShipmentTrackingReport: false,
    errorGetShipmentTrackingReport: null,
    shipmentTrackingReport: null,
    loadingAggregatedDelayedShipments: false,
    errorGetAggregatedDelayedShipments: null,
    aggregatedDelayedShipments: null,
    aggregatedDelayedShipmentsPagination: PAGINATION_DEFAULT_VALUE,
    loadingAggregatedDelayedShipmentsReport: false,
    errorGetAggregatedDelayedShipmentsReport: null,
    loadingAddressReport: false,
    errorGetAddressReport: null,
    addressReport: null,
    addressReportPagination: PAGINATION_DEFAULT_VALUE,
    loadingAddressReportFile: false,
    errorGetAddressReportFile: null,
    addressReportFile: null,
};

const TrackingReports = (state: State = INIT_STATE, action: TrackingReportsAction): any => {
    switch (action.type) {
        case TrackingReportsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REQUEST: {
                    return { 
                        ...state, 
                        loadingDelayedFacilities: false, 
                        delayedFacilities: action.payload.data.delayedFacilities,
                        delayedFacilitiesPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                case TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REPORT_REQUEST: {
                    return {
                        ...state,
                        loadingDelayedFacilitiesReport: false,
                        delayedFacilitiesReport: action.payload.data,
                    };
                }
                case TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_RECORDS_REQUEST: {
                    return { 
                        ...state, 
                        loadingShipmentTrackingRecords: false, 
                        shipmentTrackingRecords: action.payload.data.shipmentTrackingRecords,
                        shipmentTrackingRecordsPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                case TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_REPORT_REQUEST: {
                    return {
                        ...state,
                        loadingShipmentTrackingReport: false,
                        shipmentTrackingReport: action.payload.data,
                    };
                }
                case TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REQUEST: {
                    return {
                        ...state,
                        loadingAggregatedDelayedShipments: false,
                        aggregatedDelayedShipments: action.payload.data.aggregatedDelayedShipments,
                        aggregatedDelayedShipmentsPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                case TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REPORT_REQUEST: {
                    return {
                        ...state,
                        loadingAggregatedDelayedShipmentsReport: false,
                        aggregatedDelayedShipmentsReport: action.payload.data,
                    };
                }
                case TrackingReportsActionTypes.GET_ADDRESS_REPORT_REQUEST: {
                    return {
                        ...state,
                        loadingAddressReport: false,
                        addressReport: action.payload.data.addressReport,
                        addressReportPagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                case TrackingReportsActionTypes.GET_ADDRESS_REPORT_FILE_REQUEST: {
                    return {
                        ...state,
                        loadingAddressReportFile: false,
                        addressReportFile: action.payload.data,
                    };
                }
                default:
                    return { 
                        ...state, 
                        loadingDelayedFacilities: false, 
                        loadingDelayedFacilitiesReport: false, 
                        loadingShipmentTrackingRecords: false, 
                        loadingShipmentTrackingReport: false, 
                        loadingAggregatedDelayedShipments: false,
                        loadingAggregatedDelayedShipmentsReport: false,
                        loadingAddressReport: false,
                        loadingAddressReportFile: false,
                        errorGetDelayedFacilities: null, 
                        errorGetDelayedFacilitiesReport: null, 
                        errorGetShipmentTrackingRecords: null, 
                        errorGetShipmentTrackingReport: null, 
                        errorGetAggregatedDelayedShipments: null, 
                        errorGetAggregatedDelayedShipmentsReport: null,
                        errorGetAddressReport: null,
                        errorGetAddressReportFile: null,
                    };
            }

        case TrackingReportsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REQUEST: {
                    return { ...state, loadingDelayedFacilities: false, errorGetDelayedFacilities: action.payload.error };
                }
                case TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REPORT_REQUEST: {
                    return { ...state, loadingDelayedFacilitiesReport: false, errorGetDelayedFacilitiesReport: action.payload.error };
                }
                case TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_RECORDS_REQUEST: {
                    return { ...state, loadingShipmentTrackingRecords: false, errorGetShipmentTrackingRecords: action.payload.error };
                }
                case TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_REPORT_REQUEST: {
                    return { ...state, loadingShipmentTrackingReport: false, errorGetShipmentTrackingReport: action.payload.error };
                }
                case TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REQUEST: {
                    return { ...state, loadingAggregatedDelayedShipments: false, errorGetAggregatedDelayedShipments: action.payload.error };
                }
                case TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REPORT_REQUEST: {
                    return { ...state, loadingAggregatedDelayedShipmentsReport: false, errorGetAggregatedDelayedShipmentsReport: action.payload.error };
                }
                case TrackingReportsActionTypes.GET_ADDRESS_REPORT_REQUEST: {
                    return { ...state, loadingAddressReport: false, errorGetAddressReport: action.payload.error };
                }
                case TrackingReportsActionTypes.GET_ADDRESS_REPORT_FILE_REQUEST: {
                    return { ...state, loadingAddressReportFile: false, errorGetAddressReportFile: action.payload.error };
                }
                default:
                    return { 
                        ...state, 
                        loadingDelayedFacilities: false, 
                        loadingDelayedFacilitiesReport: false, 
                        loadingShipmentTrackingRecords: false, 
                        loadingShipmentTrackingReport: false, 
                        loadingAggregatedDelayedShipments: false,
                        loadingAggregatedDelayedShipmentsReport: false,
                        loadingAddressReport: false,
                        loadingAddressReportFile: false,
                        errorGetDelayedFacilities: null, 
                        errorGetDelayedFacilitiesReport: null, 
                        errorGetShipmentTrackingRecords: null, 
                        errorGetShipmentTrackingReport: null, 
                        errorGetAggregatedDelayedShipments: null, 
                        errorGetAggregatedDelayedShipmentsReport: null,
                        errorGetAddressReport: null,
                        errorGetAddressReportFile: null,
                    };
            }

        case TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REQUEST:
            return { ...state, loadingDelayedFacilities: true, delayedFacilities: null };
        case TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REPORT_REQUEST:
            return { ...state, loadingDelayedFacilitiesReport: true, delayedFacilitiesReport: null };
        case TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_RECORDS_REQUEST:
            return { ...state, loadingShipmentTrackingRecords: true, shipmentTrackingRecords: null };
        case TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_REPORT_REQUEST:
            return { ...state, loadingShipmentTrackingReport: true, shipmentTrackingReport: null };
        case TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REQUEST:
            return { ...state, loadingAggregatedDelayedShipments: true, aggregatedDelayedShipments: null };
        case TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REPORT_REQUEST:
            return { ...state, loadingAggregatedDelayedShipmentsReport: true, aggregatedDelayedShipmentsReport: null };
        case TrackingReportsActionTypes.GET_ADDRESS_REPORT_REQUEST:
            return { ...state, loadingAddressReport: true, addressReport: null };
        case TrackingReportsActionTypes.GET_ADDRESS_REPORT_FILE_REQUEST:
            return { ...state, loadingAddressReportFile: true, addressReportFile: null };
        case TrackingReportsActionTypes.RESET_STATE:
            return INIT_STATE;
        default:
            return { 
                ...state, 
                loadingDelayedFacilities: false, 
                loadingDelayedFacilitiesReport: false, 
                loadingShipmentTrackingRecords: false, 
                loadingShipmentTrackingReport: false, 
                loadingAggregatedDelayedShipments: false,
                loadingAggregatedDelayedShipmentsReport: false,
                loadingAddressReport: false,
                loadingAddressReportFile: false,
                errorGetDelayedFacilities: null, 
                errorGetDelayedFacilitiesReport: null, 
                errorGetShipmentTrackingRecords: null, 
                errorGetShipmentTrackingReport: null, 
                errorGetAggregatedDelayedShipments: null, 
                errorGetAggregatedDelayedShipmentsReport: null,
                errorGetAddressReport: null,
                errorGetAddressReportFile: null,
            };
    }
};

export default TrackingReports;
